import React, { FC, memo, useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";

import { UserContext } from "@/components/User";
import { Widget } from "@/components/Widget";
import { fetchJobRequestTopMatchingConsultantProfiles } from "@/data/job-requests";
import { JobRequest } from "@/data/job-requests/types/JobRequest";
import { useFetcher } from "@/hooks/http";

import { JobRequestMatchingConsultantRecord } from "./JobRequestMatchingConsultantRecord";

interface IJobRequestMatchingConsulatantProps {
  jobRequest: JobRequest;
}

interface IComponentProps extends IJobRequestMatchingConsulatantProps {}

export const JobRequestMatchingConsultant: FC<IComponentProps> = memo(props => {
  const { jobRequest } = props;
  const { contextCompany } = useContext(UserContext);
  const { t } = useTranslation("session");

  const { payload, fetch } = useFetcher(
    fetchJobRequestTopMatchingConsultantProfiles,
    {
      jobRequestId: jobRequest.id,
      companyId: contextCompany && contextCompany.id,
      sortBy: "user.lastName",
      order: "ASC",
    },
    [contextCompany, jobRequest],
  );

  const handleModalClosed = useCallback(() => {
    fetch();
  }, [fetch]);

  if (!payload || (payload && payload.numberOfElements === 0)) {
    return null;
  }
  // TODO: remove when backend sorting fixed
  const profiles = payload.content.sort((a, b) => a.lastName.localeCompare(b.lastName));

  return (
    <Widget title={t("JOB_REQUESTS.DETAIL.WIDGET_CONSULTANTS_TITLE")}>
      {profiles.map(profile => (
        <JobRequestMatchingConsultantRecord
          key={profile.id}
          profile={profile}
          jobRequest={jobRequest}
          onModalClosed={handleModalClosed}
        />
      ))}
    </Widget>
  );
});
